import type { JSX } from 'react';
import { IDashboardWidgetCatalogItem } from '../../../types/IDashboardWidgetCatalogItem';
import LoopRounded from '@mui/icons-material/LoopRounded';
import { AverageCycleCountWidgetConfiguration } from './AverageCycleCountWidgetConfiguration';
import { DashboardWidgetType } from '@/modules/dashboards/types/DashboardWidgetType';
import { v4 } from 'uuid';
import { TFunction } from 'i18next';
import { DashboardWidgetCatalogItemImageColorType } from '../../widget-catalog/DashboardWidgetCatalogItemImage';
import { LayoutItem } from 'react-grid-layout';

export class AverageCycleCountWidgetCatalogItem implements IDashboardWidgetCatalogItem<AverageCycleCountWidgetConfiguration> {
  title: string;
  description: string;
  icon: JSX.Element;
  iconColor: DashboardWidgetCatalogItemImageColorType;
  id: string;
  type: DashboardWidgetType;
  configuration: AverageCycleCountWidgetConfiguration;
  layout: LayoutItem;

  constructor(t: TFunction) {
    this.title = t('dashboard.averageCycleCountWidget.title');
    this.description = t('dashboard.averageCycleCountWidget.description');
    this.icon = <LoopRounded />;
    this.iconColor = 'blue';
    this.id = v4();
    this.type = DashboardWidgetType.AverageCycleCountWidget;
    this.configuration = new AverageCycleCountWidgetConfiguration(t);
    this.layout = {
      h: 1,
      w: 1,
      i: v4(),
      x: 0,
      y: 0,
      maxH: 2,
      maxW: 2,
      minH: 1,
      minW: 1,
    };
  }

  localize(t: TFunction) {
    this.title = t(this.title);
    this.description = t(this.description);
  }
}
